<template>
  	<div id="sendEnvelope">
  		<mt-header  :title="$t('envelope.title')" fixed>
        <mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
        <mt-button slot="right" @click.native="redEnvelopeRecord()"><span style="color:#1296db;">{{$t('envelope.owned')}}</span></mt-button>
      </mt-header>
      <div class="container">
        <div class="photo">
          <img v-bind:src="initMessage.avatar" alt="" class="oImg">
          <span class="currency_name">{{initMessage.nickname}}</span>
          <div class="amount_of wx_rt" @click="changePhoto()">
            <img src="../../assets/img/coinDetail/img_qiehuan.png" alt="">
          </div>
        </div>
        <mt-cell :title="coin_symbol" is-link to="/redCoinList"  class="dl-line"></mt-cell>
        <mt-cell :title="$t('envelope.amount')"  class="dl-line">
          <input type="text" placeholder="0.00" class="int" v-model="total_amount" value="total_amount">
        </mt-cell>
        <mt-cell :title="$t('envelope.quantity')" class="dl-line">
          <input type="text" :placeholder="$t('envelope.quantity_hint')" class="int" v-model="total_num" value="total_num">个
        </mt-cell>
        <div class="dl-line" style="padding:15px 0">
          <input type="text" v-model="wishesList" value="wishesList" class="wish">
        </div>
        <!-- <mt-cell :title="wishesList" style="color:#8c92a8;"></mt-cell> -->
        <div class="footer wx_fontSize3" @click="haveRed()">{{$t('envelope.generate')}}</div>
      </div>
      <div class="box" v-show="isShow">
        <div class="mag">
          <mt-cell :title="$t('envelope.title2')">
            <span @click="close()">
              <img src="../../assets/img/ico_close_lan.png" alt="" style="width:20px;height:20px">
            </span>
          </mt-cell>
          <mt-cell :title="$t('envelope.total')">
            <span>{{total_amount}}{{coin_symbol}}</span>
          </mt-cell>
          <mt-cell :title="$t('envelope.quantity')">
            <span>{{total_num}}个</span>
          </mt-cell>
          <mt-cell :title="$t('envelope.wishes')">
            <span>{{wishesList}}</span>
          </mt-cell>
          <div class="footer wx_fontSize3 zhifu" @click="surePay()">{{$t('envelope.submit')}}</div>
        </div>
      </div>
      <div class="box" ref="box" v-show="show_pay_pwd">
        <div class="mag">
          <mt-cell :title="$t('envelope.enter_pass')">
            <span @click="close()">
              <img src="../../assets/img/ico_close_lan.png" alt="" style="width:20px;height:20px">
            </span>
          </mt-cell>
          <div class="passContainer">
            <Password  ref="pay_pass" v-on:end="onEnd"></Password>
          </div>
        </div>
      </div>
      <div class="box" v-show="red_envelope">
        <div class="red_main">
          <mt-cell :title="$t('envelope.choose_path')">
            <span @click="senRed()">
              <img src="../../assets/img/ico_close_lan.png" alt="" style="width:20px;height:20px">
            </span>
          </mt-cell>
          <span class='Redmain'>
            <img src="../../assets/img/red.png" alt="">
            <span class="Redphoto"><img v-bind:src="initMessage.avatar" alt=""></span>
            <p class="wishes wx_fontSize2">{{wishes.red_envelope_tips}}</p>
          </span>
          <p class="wx_fontSize2 detail">{{$t('envelope.view')}}</p>
          <div class="footer wx_fontSize3 zhifu" style="margin-top:6%;" @click="doshare()">{{$t('envelope.share')}}</div>
        </div>
      </div>
  	</div>
</template>

<script>
import { Toast } from "mint-ui";
import { httpRedEnvelopeInit ,httpRedEnvelopeMake } from "@/api/index";
import Password from "@/components/Password";
import { validateEmpty } from "@/utils/validate";
import { share } from "@/utils/index";
export default {
  components: { Toast, Password },
  data:function(){
    return{
      cataList:[],
      initMessage:{},
      wishes:[],
      wishesList:'',
      id:'',
      coin_symbol:this.$t('envelope.choose_coin'),
      total_amount:'',
      total_num:'',
      isShow:false,
      show_pay_pwd:true,
      red_envelope:false,
      wishes:{},
      password:'',
      cataData:{},
      pay:true,
    }
  },
  mounted(){
    this.initData();
  },
  activated(){
    if(this.$route.query.result){
      this.coin_symbol = this.$route.query.result.name;
      this.id = this.$route.query.result.id;
    }
    this.$refs.box.style.top = "1000px";
    this.isShow = false;
    this.red_envelope = false;
    this.pay = true;
  },
  methods:{
    initData: function() {
      httpRedEnvelopeInit({})
      .then(res => {
        this.cataList = res.data.nicknames.list;
        this.wishes = res.data.wishes.list;
        this.sendNum(this.cataList);
        this.sendwish(this.wishes);
      })
      .catch(() => {});
    },
    sendNum:function(arr){ 
      this.initMessage = arr[Math.floor(Math.random()*arr.length)];
    },
    sendwish:function(arr){ 
      this.wishesList = arr[Math.floor(Math.random()*arr.length)].wish_content;
    },
    getSubmit: function() {
      var p={
        'total_amount':this.total_amount,
        'total_num':this.total_num,
        'coin_symbol':this.coin_symbol,
        'nickname':this.initMessage.nickname,
        'wish':this.wishesList,
        'passWord_pay':this.password
      }
      httpRedEnvelopeMake(p)
      .then(res => {
        if(res.code == 1){
          this.wishes = res.data;
          this.$refs.box.style.top = "1000px";
          this.red_envelope = !this.red_envelope;
          this.cataData = res.data;
        }else{
          Toast(res.msg)
        }
      })
      .catch(() => {});
    },
    redEnvelopeRecord(){
      this.$router.push("/redEnvelopeRecord");
    },
    haveRed(){
      if (this.$store.state.userInfo.has_paypwd != 1) {
          Toast(this.$t('envelope.need_pay_password'))
          return;
      }
      if (validateEmpty(this.total_amount) || validateEmpty(this.total_num) || this.coin_symbol==this.$t('envelope.choose_coin')) {
        Toast(this.$t("empty"));
        return;
      }
      this.isShow = !this.isShow;
    },
    changePhoto(){
      this.initData();
    },
    close(){
      this.isShow = false;
      this.$refs.box.style.top = "1000px";
    },
    onEnd: function(val) {
      if(val.length == 6){
        this.password = val;
        this.getSubmit();
      }
    },
    senRed(){
      this.red_envelope = !this.red_envelope;
      this.isShow = false;
      this.$refs.box.style.top = "1000px";
      this.coin_symbol = this.$t('envelope.choose_coin');
      this.total_amount = '';
      this.total_num = '';
    },
    surePay(){
      if(this.pay){
        this.$refs.box.style.top = "0px";
        this.$refs.pay_pass.focus();
        this.$refs.pay_pass.reset();        
      }else{
          this.getSubmit();
      }
      this.isShow = !this.isShow;
    },
    doshare(){
      var p={
        title:this.cataData.red_envelope_title,
        desp:this.cataData.red_envelope_tips,
        url:this.cataData.red_envelope_url
      }
      console.log(p);
      share(JSON.stringify(p));
    }
  }
}
</script>

<style scoped>
#sendEnvelope{width:100%;height:100%;overflow: hidden;}
.mint-header{background: #fff;color:#212529;border-bottom: 1px solid #e3e8ed;}
.mint-button--default{color:#656b79 !important;}
.container {
  padding: 50px 0px 10px 0px;
}
.swiper {
  height: 80px;
}
.photo{position: absolute;top:0;left:0; margin-left:10px;}
.swiper img {
  width: 100%;
  max-height: 100%;
  border-radius: 10px;
}
input::-ms-input-placeholder{
        text-align: right;
}
input::-webkit-input-placeholder{
        text-align: right;
}
.int{padding-right: 15px;text-align: right; color:#212529;}
.photo{border-bottom: 1px solid #f6f6f6;width: 100%;position: relative;height: 50px;overflow: hidden;}
.oImg{width:40px;height:40px;border:1px solid #dddddd;border-radius: 50%;margin:5px 10px;}
.currency_name{position: relative;display: inline-block;top:-15px;}
.amount_of{width:20%;text-align: right;padding:10px 0;text-align: center;color:#1296db;}
.amount_of img{width:22px;height:22px;}

.footer{width:calc(100% - 20px);height:50px;background:#1296db;line-height:50px;text-align: center;color:#ffffff;margin-top: 20px;border-radius: 0px;margin-left: 10px;}

.zhifu{width:calc(100% - 30px);margin-left:15px;margin-top:40px;}
.box {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 5;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.mag{position: absolute;bottom: 0;width:100%;background:#fff;height:60%;}
.passContainer{margin-top:30px;}
.red_main{
  position: absolute;top:17%;background:#fff;height:66%;width:90%;margin-left: 5%;border-radius: 5px;padding:5px 0 0 0;
}
.Redmain{display: block;width:100%;text-align: center;margin-top:10px;position: relative;height: 55%;}
.Redmain img{width:80%;height:100%;position: relative;}
.detail{color:#666;text-align: center;margin-top:10px;}
.Redmain .Redphoto{position: absolute;width:40px;height:40px;left:calc(50% - 20px);top:62px;}
.Redmain .Redphoto img{width:100%;height:100%;border:4px solid #fff;border-radius: 50%;}
.wishes{width:60%;margin-left: 20%;text-align: center;color:#fff;position:absolute;bottom: 20%; }
.wish{padding-left: 20px;font-weight:600;font-size: 1rem;}
.dl-line{border-bottom: 1px solid #f6f6f6;}
</style>